<form [formGroup]="forgotUsernameForm" >
  <div>
    <h3 class="text-black mt-3"><b>Let's Check Your School</b></h3>
    <p class="text-black mb-3">If your school has a <span class="text-success font-weight-bolder">zeraki school
        code</span> we can help you remember it</p>
      <!-- County -->
    <div class="form-group mb-2" *ngIf="!isMawinguRedirect || !showMawinguAdmissionForm">
      <label for="county" class="font-weight-bold">Please enter the County of your School</label>
      <select id="county" class="form-control" formControlName="county" (change)="onCountyChange()">
        <option value="" disabled selected>Choose County</option>
        <option *ngFor="let county of counties" [value]="county.code">{{ county.name }}</option>
      </select>
    </div>
    <!-- School -->
    <div class="form-group" *ngIf="!isMawinguRedirect || !showMawinguAdmissionForm">
      <label for="school" class="font-weight-bold">Please enter the Name of your School</label>
      <input id="school" class="form-control" type="text" [formControl]="schoolSearchControl"
        [disabled]="!forgotUsernameForm.get('county')?.value || loadingSchools"
        [placeholder]="isMawinguRedirect ? 'Enter and choose a school' : 'Type to search your school'"
        (focus)="showSchoolDropdown = true" (input)="onSchoolInput()" (blur)="onSchoolBlur()" />
      <div *ngIf="loadingSchools" class="text-info mt-1">Loading schools...</div>
      <ul *ngIf="showSchoolDropdown && filteredSchools.length > 0 && !loadingSchools"
        class="list-group position-absolute w-100 zindex-dropdown" style="max-height: 200px; overflow-y: auto; z-index: 1">
        <li *ngFor="let school of filteredSchools" class="list-group-item list-group-item-action cursor-pointer"
          (mousedown)="selectSchool(school)">{{ school.name }}</li>
      </ul>
    </div>
      <div *ngIf="isMawinguRedirect && showMawinguAdmissionForm && !isSchoolNotFound" class="d-flex justify-content-between mb-1">
        <div>
          <span>School Name:</span>
          <span class="text-black pl-1">{{ getSelectedSchoolName() }}</span>
        </div>
        <div>
          <span>County:</span>
          <span class="text-black pl-1">{{ getSelectedCountyName() }}</span>
        </div>
      </div>
      <!-- School not found -->
      <div *ngIf="isMawinguRedirect && showMawinguAdmissionForm && isSchoolNotFound">
        <div class="d-flex justify-content-between mb-2">
          <div>
            <span>County:</span>
            <span class="text-black pl-1">{{ getSelectedCountyName() }}</span>
          </div>
          <div>
            <span>School Name:</span>
            <span *ngIf="phoneAccountState !== 'found'" class="text-danger pl-1 pr-md-5">School not found</span>
            <span *ngIf="phoneAccountState === 'found'" class="text-black pl-1 pr-md-5"> - </span>
          </div>
        </div>
        <!-- Info banner: shown once user lands in school-not-found state -->
      <div *ngIf="showSchoolNotFoundInfoBanner"
          class="alert alert-info py-custom d-flex justify-content-between align-items-center  px-1 mb-2"
      >
        <span class="d-flex align-items-center">
          <img src="assets/images/icons/info.svg" width="24" height="24" alt="" class="mr-1" />
          <span>We couldn't find your school. Don't worry, let's check your phone numbers</span>
        </span>
        <button type="button" class="close ml-2" aria-label="Close" (click)="dismissSchoolNotFoundInfoBanner()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Found banner -->
      <div *ngIf="phoneAccountState === 'found' && showFoundBanner"
          class="alert alert-success d-flex justify-content-between align-items-start py-custom px-1 mb-2">
        <span class="d-flex align-items-center">
          <img src="assets/images/icons/successTick.svg" width="24" height="24" alt="" class="mr-1" />
          <span>Account has been found. You can now login</span>
        </span>
        <button type="button" class="close ml-2" aria-label="Close" (click)="dismissFoundBanner()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Not found banner -->
      <div *ngIf="phoneAccountState === 'notfound' && showNotFoundBanner"
          class="alert alert-danger d-flex justify-content-between align-items-start py-custom px-1 mb-2">
        <span class="d-flex align-items-center">
          <img src="assets/images/icons/errorInfo.svg" width="24" height="24" alt="" class="mr-1" />
          <span>Account has not been found</span>
        </span>
        <button type="button" class="close ml-2" aria-label="Close" (click)="dismissNotFoundBanner()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="form-group mb-2">
        <label for="checkPhoneNumber">Check phone number *</label>
        <div class="input-group">
          <input id="checkPhoneNumber" class="form-control" [formControl]="checkPhoneNumber"
            placeholder="start with 07... or 01..." maxlength="10"
            [ngClass]="{
              'is-valid border-success': phoneAccountState === 'found',
              'is-invalid border-danger': phoneAccountState === 'notfound'
            }" />
        </div>
        <small *ngIf="phoneAccountState === 'idle' || phoneAccountState === 'checking'" class="text-black font-weight-bold d-block mt-custom">
          Check using a phone number you have used to login before
        </small>
        <small *ngIf="phoneAccountState === 'found'" class="text-success">Account linked to phone number found</small>
        <small *ngIf="phoneAccountState === 'notfound'" class="text-danger">
          Try another phone number, or create a free account
        </small>
      </div>

      <!-- Revealed once account is found -->
      <div *ngIf="phoneAccountState === 'found'">
        <div class="form-group mb-2">
          <label for="mawinguEmail">Please provide your email (optional)</label>
          <input id="mawinguEmail" class="form-control" [formControl]="mawinguOptionalEmail" placeholder="example@gmail.com" />
          <small>We will use this in case of password resetting</small>
        </div>
      </div>
      <button class="btn btn-primary btn-block mt-2" type="button" (click)="proceedToLoginWithPhone()"
        [disabled]="phoneAccountState !== 'found' || loggingIn">
        <span *ngIf="!loggingIn">Proceed to Login</span>
        <span *ngIf="loggingIn" class="spinner-border spinner-border-sm"></span>
      </button>

      <div class="text-center mt-2" *ngIf="phoneAccountState !== 'found'"> 
        <a href="javascript:void(0)" (click)="goToRegister()" class="font-weight-bolder" style="text-decoration: underline;">Create a Free Account</a>
      </div>
    </div> 
    <!--end of school not found  -->
    
    <div *ngIf="(isMawinguRedirect && showMawinguAdmissionForm  && !isSchoolNotFound) || (!isMawinguRedirect && forgotUsernameForm.get('county')?.value && forgotUsernameForm.get('school')?.value && forgotUsernameForm.get('school')?.value !== -1)">
      <div class="form-group">
        <label for="admission">Please enter your Admission Number</label>
        <input id="admission" class="form-control" formControlName="admission" placeholder="e.g 12345"
          [ngClass]="{'is-invalid error': error}" 
          (blur)="onAdmissionBlur()"
          (keyup.enter)="onAdmissionBlur()"/>
        <small *ngIf="!error">This is also your default password when signing in</small>
        <div *ngIf="error" class="invalid-feedback d-block" style="font-weight:bold;">{{ error }}</div>
      </div>

      <button *ngIf="!isMawinguRedirect && !generatedUsername" class="btn btn-primary btn-block mt-2" type="button" (click)="fetchUsername()"
        [disabled]="!forgotUsernameForm.get('admission')?.value || loadingUsername">
        <span *ngIf="!loadingUsername">Continue</span>
        <span *ngIf="loadingUsername" class="spinner-border spinner-border-sm"></span>
      </button>
    </div>

    <div *ngIf="isMawinguRedirect && !showMawinguAdmissionForm " class="mt-2" style="position: relative; z-index: 0">
      <button *ngIf="!showMawinguAdmissionForm" class="btn btn-primary btn-block mt-2" type="button" 
        (click)="showMawinguAdmissionForm = true"
        [disabled]="!forgotUsernameForm.get('county')?.value || !forgotUsernameForm.get('school')?.value">
        <span *ngIf="!loadingUsername">Continue</span>
        <span *ngIf="loadingUsername" class="spinner-border spinner-border-sm"></span>
      </button>
      <button *ngIf="!showMawinguAdmissionForm" class="btn btn-outline-success btn-block mt-2 mb-2" type="button" (click)="skipToLogin()">
        Skip
      </button>
    </div>

    <!-- show when user can't find their school -->
    <div *ngIf="!isMawinguRedirect && forgotUsernameForm.get('school')?.value == -1" class="form-group">
      <div class="alert alert-info p-1">
        Can't find your school? <a href="javascript:void(0)" (click)="switchToSignUpForm.emit()">Create a Free Account</a>
      </div>
    </div>

    <!-- Username Field -->
    <div *ngIf="generatedUsername ">
      <div class="form-group">
        <label>Here is your School Based Username</label>
        <div class="input-group">
          <input class="form-control text-center" [value]="generatedUsername" readonly />
          <div class="input-group-append">
            <button class="btn"
              style="background: #eeeeee; border-top: 1px solid #d6d6d6; border-bottom: 1px solid #d6d6d6; border-right: 1px solid #d6d6d6;"
              type="button" (click)="copyUsername()" [disabled]="!generatedUsername">
              📋
            </button>
          </div>
        </div>
        <small>Click to copy username</small>
      </div>
    </div>
    <!-- <hr *ngIf="showParentForm" /> -->

    <!-- Parent Phone/Email Form -->
    <form *ngIf="showParentForm" [formGroup]="parentForm" (ngSubmit)="onParentFormSubmit()">
      <div *ngIf="parentFormSuccess" class="alert alert-success py-2">Parent info updated successfully! Redirecting to
        login...</div>
      <div *ngIf="parentFormError" class="alert alert-danger py-2">{{ parentFormError }}</div>
      <div class="form-group mb-2">
        <label for="parentEmail">Please provide your email (optional)</label>
        <input id="parentEmail" class="form-control" formControlName="parentEmail" placeholder="example@gmail.com" />
        <small>We will use this in case of password resetting</small>
      </div>
      <button class="btn btn-primary btn-block mt-2 mb-1" type="submit"
        [disabled]="parentForm.invalid || updatingParentInfo || parentFormSuccess">
        <span *ngIf="!updatingParentInfo">Proceed to Login</span>
        <span *ngIf="updatingParentInfo" class="spinner-border spinner-border-sm"></span>
      </button>
    </form>
  </div>
</form>